import { render } from "./Automata.vue?vue&type=template&id=1b89c3b9&scoped=true"
import script from "./Automata.vue?vue&type=script&lang=ts"
export * from "./Automata.vue?vue&type=script&lang=ts"

import "./Automata.vue?vue&type=style&index=0&id=1b89c3b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b89c3b9"

export default script